<section class="invoice-ocr-wrapper">
  <h1 class="main-title">{{ "CASE_FORM.FORMS.INVOICE.TITLE" | translate }}</h1>
  <div class="subtitle">
    {{ "CASE_FORM.FORMS.INVOICE.START_DESCRIPTION" | translate }}
  </div>
  <div class="subtitle">
    {{ "CASE_FORM.FORMS.INVOICE.HELP_DESCRIPTION" | translate }}
  </div>

  <mat-progress-spinner
    *ngIf="loading"
    mode="indeterminate"
    diameter="100"
  ></mat-progress-spinner>

  <div
    *ngIf="!loading"
    class="upload-area"
    dropzone
    (dropped)="fileDropped($event)"
    (click)="upload.click()"
  >
    <input
      #upload
      (change)="fileDropped(upload.files)"
      hidden
      type="file"
      multiple="false"
      accept="application/pdf,
      image/png,
      image/jpeg,
      image/gif,
      image/webp"
    />
    <div class="badge">{{ "CASE_FORM.FORMS.INVOICE.BADGE" | translate }}</div>
    <div class="dropzone-box">
      <div class="cloud-icon" aria-hidden="true">
        <payee-icon name="upload-cloud" width="48px" height="48px"></payee-icon>
      </div>
      <div class="file-info">
        {{ "CASE_FORM.FORMS.INVOICE.FILE_INFO" | translate }}
      </div>
      <div class="or-divider">
        {{ "CASE_FORM.FORMS.INVOICE.OR" | translate }}
      </div>
      <button type="button" payee-button color="blue-payee" width="short">
        <div class="select-file-btn">
          <payee-icon name="plus-grey"></payee-icon>
          <span> {{ "CASE_FORM.FORMS.INVOICE.FILE_SELECT" | translate }}</span>
        </div>
      </button>
    </div>
  </div>

  <payee-info>
    {{ "CASE_FORM.FORMS.INVOICE.INFO_BAR" | translate }}
  </payee-info>

  <div *ngIf="isGuest" class="login-link">
    {{ "CASE_FORM.FORMS.INVOICE.ALREADY_REGISTERED" | translate }}
    <a routerLink="/login">{{ "CASE_FORM.FORMS.INVOICE.LOGIN" | translate }}</a>
  </div>

  <div class="or-separator">
    <span>{{ "CASE_FORM.FORMS.INVOICE.OR" | translate }}</span>
  </div>

  <div class="alternative-upload-options">
    <a
      href="https://www.szamlazz.hu/digitalis-koveteleskezeles/"
      class="option-card"
    >
      <img
        src="assets/shared/global-images/case-form/invoice/szamlazzhu.png"
        width="144px"
        height="47px"
        alt="Számlázz.hu"
      />
      <div class="option-desc">
        {{ "CASE_FORM.FORMS.INVOICE.OPTION_SZAMLAZZHU_DESC" | translate }}
      </div>
    </a>
    <a href="https://tally.so/r/3j0evx" class="option-card">
      <img
        src="assets/shared/global-images/case-form/invoice/excel.png"
        width="74px"
        height="42px"
        alt="Excel"
      />
      <div class="option-desc">
        {{ "CASE_FORM.FORMS.INVOICE.OPTION_EXCEL_DESC" | translate }}
      </div>
    </a>
    <a href="https://marketplace.stripe.com/apps/payee" class="option-card">
      <img
        src="assets/shared/global-images/case-form/invoice/stripe.png"
        width="72px"
        height="30px"
        alt="Stripe"
      />
      <div class="option-desc">
        {{ "CASE_FORM.FORMS.INVOICE.OPTION_STRIPE_DESC" | translate }}
      </div>
    </a>
    <a href="https://payee.readme.io/reference" class="option-card">
      <img
        src="assets/shared/global-images/case-form/invoice/api.png"
        width="33px"
        height="33px"
        alt="API"
      />
      <div class="option-desc">
        {{ "CASE_FORM.FORMS.INVOICE.OPTION_API_DESC" | translate }}
      </div>
    </a>
  </div>
</section>

<div class="help-section">
  <h2 class="help-title">
    {{ "CASE_FORM.FORMS.INVOICE.HELP_TITLE" | translate }}
  </h2>
  <div class="help-cards">
    <div class="help-card">
      <img
        src="assets/shared/global-images/case-form/invoice/send.svg"
        width="40px"
        height="40px"
        alt="Email"
      />
      <div class="help-card-title">
        {{ "CASE_FORM.FORMS.INVOICE.HELP_EMAIL_TITLE" | translate }}
      </div>
      <div class="help-card-desc">
        {{ "CASE_FORM.FORMS.INVOICE.HELP_EMAIL_DESC" | translate }}
      </div>
      <a href="https://www.payee.tech/contact">
        <button payee-button class="help-btn">
          {{ "CASE_FORM.FORMS.INVOICE.HELP_EMAIL_BTN" | translate }}
        </button>
      </a>
    </div>
    <div class="help-card">
      <img
        src="assets/shared/global-images/case-form/invoice/chat.svg"
        width="40px"
        height="40px"
        alt="Chat"
      />
      <div class="help-card-title">
        {{ "CASE_FORM.FORMS.INVOICE.HELP_CHAT_TITLE" | translate }}
      </div>
      <div class="help-card-desc">
        {{ "CASE_FORM.FORMS.INVOICE.HELP_CHAT_DESC" | translate }}
      </div>
      <button payee-button class="help-btn" (click)="openIntercomWidget()">
        {{ "CASE_FORM.FORMS.INVOICE.HELP_CHAT_BTN" | translate }}
      </button>
    </div>
    <div class="help-card">
      <img
        src="assets/shared/global-images/case-form/invoice/user_check.svg"
        width="40px"
        height="40px"
        alt="Consultation"
      />
      <div class="help-card-title">
        {{ "CASE_FORM.FORMS.INVOICE.HELP_CONSULT_TITLE" | translate }}
      </div>
      <div class="help-card-desc">
        {{ "CASE_FORM.FORMS.INVOICE.HELP_CONSULT_DESC" | translate }}
      </div>
      <a href="https://www.payee.tech/free-consultation">
        <button payee-button class="help-btn">
          {{ "CASE_FORM.FORMS.INVOICE.HELP_CONSULT_BTN" | translate }}
        </button>
      </a>
    </div>
  </div>
</div>
